import { httpClient, getCurrentLanguage } from "@utils";

import { OfferService } from "@gp/hub";

import {
	MenuResponse,
	PrematchMenuApiFilter,
} from "@api-types/offer/PrematchMenuResponse";
import { getApiRequestContext } from "@utils/api-config";
import { ApiRequestContextData } from "@utils/api-config/types";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";

class PrematchOfferApiService extends OfferService {
	constructor() {
		super({
			apiClient: {
				get: async (relativeUrl: string) => {
					const context = getApiRequestContext();
					const url = `${WEBPACK_BASE_PROXY_ADDRESS}${context?.agencyKey}/${relativeUrl}`;
					const response = await httpClient.get(
						url,
						this.getRequestHeaders(context),
						{ responseType: "raw" }
					);
					return await response.json();
				},
			},
			callerEnvironment: WEBPACK_ENVIRONMENT_KEY,
			getLanguage: () => getCurrentLanguage(),
		});
	}

	async getPrematchMenu<K extends PrematchMenuApiFilter>(
		filter: K
	): Promise<MenuResponse<K>> {
		return this.getSportsMenu(filter);
	}

	getRequestHeaders = (
		context: ApiRequestContextData | null
	): HeadersInit => {
		const appHeaders = getApplicationRequestHeaders(context);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};
}

export default new PrematchOfferApiService();
